import * as getter from '../types/getters'
import * as action from '../types/actions'

export const state = {
    loading: false,
}

export const mutations = {
    [action.LOADING_UPDATE](state, loading) {
        state.loading = loading
    },
}

export const actions = {
    [action.LOADING_UPDATE]({ commit }, loading) {
        commit(action.LOADING_UPDATE, loading)
    },
}

export const getters = {
    [getter.LOADING]: (state) => state.loading,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/loading.js